<div class="stepper-parent d-flex flex-row align-items-center justify-content-center">
  <div class="stepper-child d-flex flex-column align-items-center justify-content-center"
    [style.width.%]=calculatefinaltotal *ngFor="let stepper of stepperdata;" (click)="fnStatus(stepper, id)" #stepperChildClass >
    <div class="stepper-group d-flex flex-column align-items-center justify-content-center">
      <div class="stepper-icon d-flex align-items-center justify-content-center" >
        <img src="{{'../../../../assets/images/creditor-portal/' + stepper?.path}}" alt="stepperIcon">
      </div>
    </div>
    <div class="stepper-name {{stepper.isComplete? 'active' : 'incomplete'}}">{{stepper.name}}</div>
  </div>
</div>
